import { Icon, type IconProps } from "@chakra-ui/react";

const BrandZapOffIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.33333 5.33325L2.72897 8.45849C2.49643 8.73753 2.38016 8.87706 2.37839 8.99489C2.37684 9.09733 2.42249 9.19479 2.50217 9.25918C2.59383 9.33325 2.77545 9.33325 3.13869 9.33325H8L7.33333 14.6666L10.6667 10.6666M10.4334 6.66658H12.8613C13.2245 6.66658 13.4062 6.66658 13.4978 6.74066C13.5775 6.80505 13.6232 6.90251 13.6216 7.00494C13.6198 7.12278 13.5036 7.2623 13.271 7.54135L12.3668 8.62639M7.0485 3.27502L8.66664 1.33325L8.26683 4.53173M14 13.9999L2 1.99992"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};

export default BrandZapOffIcon;
